module.exports = __webpack_public_path__ + "img/10-min.ec109173.jpg";